(function () {
  'use strict';

  angular.module('app').component('addIncomingPrepayment', addIncomingPrepayment());

  function addIncomingPrepayment() {
    return {
      bindings: {
        booking: '<',
        index: '<',
        onIncomingPrepaymentSaved: '&',
        incomingPrepayments: '<',
        incomingPrepaymentsTotalPercentage: '<',
      },
      controller: AddIncomingPrepaymentComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/prepayment-reports/incoming-prepayments/modals/add-incoming-prepayment/' +
        'add-incoming-prepayment.component.html',
    };
  }

  AddIncomingPrepaymentComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'IncomingPrepaymentService',
  ];

  function AddIncomingPrepaymentComponent(config, UtilService, moment, IncomingPrepaymentService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.prepaymentPaymentTimes = config.PREPAYMENT_PAYMENT_TIMES;
    vm.editMode = false;

    vm.$onInit = function () {
      // Initializers
      if (vm.index === '') {
        // New
        vm.addIncomingPrepayment();
      } else {
        vm.editMode = true;
      }
    };

    // public methods
    // -----------------------
    vm.validateIncomingPrepayments = function () {
      if (vm.incomingPrepayments.length === 1) return;

      let todayDate = moment(new Date()).format('YYYY-MM-DD');

      vm.hasElementsAlike = false;
      vm.elementsAlike = [];

      vm.dateEquals = false;
      vm.elementAtIndex = [];

      vm.prepaymentEquals = false;
      vm.elementAtUnique = [];

      let total = 0;

      // TODO: this code must be refactored
      vm.incomingPrepayments.map((item, indexItem) => {
        vm.incomingPrepayments.forEach((element, indexElement) => {
          if (
            (vm.prepaymentPaymentTimes.findIndex(
              (prePayOption1) => prePayOption1.payment_time === item.payment_time
            ) ===
              vm.prepaymentPaymentTimes.findIndex(
                (prePayOption2) => prePayOption2.payment_time === element.payment_time
              ) &&
              indexItem !== indexElement &&
              item.payment_time !== 'days_before_service' &&
              element.payment_time !== 'days_before_service') ||
            (findDuplicatedDays(element) > 1 &&
              item.payment_time === 'days_before_service' &&
              element.payment_time === 'days_before_service')
          ) {
            vm.elementsAlike.push(indexElement);
            vm.hasElementsAlike = true;
          }

          let dateCalculated = moment(vm.booking.start_date)
            .subtract(element.days_before_service, 'days')
            .format('YYYY-MM-DD');

          if (element.payment_time === 'days_before_service' && dateCalculated <= todayDate) {
            addUnUniqueElements(indexElement);
          }

          if (
            element.payment_time === 'on_booking_date' &&
            findDuplicatedIncomingPrepayments('on_booking_date')
          ) {
            addUnUniqueElements(indexElement);
          } else if (
            element.payment_time === 'days_before_service' &&
            findDuplicatedDays(element) > 1
          ) {
            addUnUniqueElements(indexElement);
          } else if (
            element.payment_time === 'on_service_date' &&
            findDuplicatedIncomingPrepayments('on_service_date')
          ) {
            addUnUniqueElements(indexElement);
          } else if (
            element.payment_time === 'pay_later' &&
            findDuplicatedIncomingPrepayments('pay_later')
          ) {
            addUnUniqueElements(indexElement);
          }
        });

        item.percentage = item.percentage || 1;
        item.days_before_service = item.days_before_service || 1;

        total += parseFloat(item.percentage || 0);
      });

      vm.totalPercentage = total;
    };

    vm.addIncomingPrepayment = function () {
      vm.incomingPrepayments.push({
        percentage: 100 - (vm.totalPercentage || vm.incomingPrepaymentsTotalPercentage),
        payment_time: vm.prepaymentPaymentTimes[0].payment_time, // on_booking_date
        days_before_service: 0,
      });

      vm.totalPercentage = vm.incomingPrepayments.reduce((total, x) => total + x.percentage, 0);
      vm.validateIncomingPrepayments();
    };

    vm.removeIncomingPrepayment = function (index) {
      vm.incomingPrepayments.splice(index, 1);

      vm.validateIncomingPrepayments();
    };

    vm.saveIncomingPrepayments = function () {
      let data;

      vm.formErrors = false;
      vm.sendingIncomingPrepayments = true;
      data = setIncomingPrepayments();

      IncomingPrepaymentService.saveIncomingPrepayment(data).then(function (data) {
        let status = data.status;
        let response = data.response;

        if (status) {
          vm.onIncomingPrepaymentSaved({ incomingPrepayment: response });
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingIncomingPrepayments = false;
      });
    };

    vm.isBeforeService = function (incomingPrepayment) {
      if (incomingPrepayment.payment_time === vm.prepaymentPaymentTimes[1].payment_time) {
        incomingPrepayment.days_before_service = incomingPrepayment.days_before_service || 1;

        return true;
      }

      incomingPrepayment.days_before_service = 1;

      return false;
    };

    // private methods
    // -----------------------
    function findDuplicatedIncomingPrepayments(type) {
      return vm.incomingPrepayments.filter((x) => x.payment_time === type) > 1;
    }

    function findDuplicatedDays(item) {
      return vm.incomingPrepayments.filter(
        (x) =>
          x.days_before_service === item.days_before_service &&
          x.payment_time === 'days_before_service'
      ).length;
    }

    function addUnUniqueElements(index) {
      if (vm.editMode && index !== vm.index) {
        vm.elementAtUnique.push(index);

        if (!(vm.editMode && vm.elementAtUnique.includes(vm.index))) {
          vm.prepaymentEquals = !vm.prepaymentEquals;
        }
      }
    }

    function setIncomingPrepayments() {
      let incomingPrepayments = [];
      let updatedIncomingPrepayments = [];
      let addIncomingPrepayments = [];

      updatedIncomingPrepayments = vm.incomingPrepayments
        .filter((i) => i.id)
        .map((i) => {
          return {
            ...i,
            amount: vm.UtilService.roundNum((i.percentage / 100) * vm.booking.total_price),
          };
        });

      addIncomingPrepayments = vm.incomingPrepayments.filter((i) => !i.id);

      addIncomingPrepayments.forEach((item) => {
        let due_date;
        let daysBeforeService = 0;

        switch (
          item.payment_time // item.payment_time.payment_time ||
        ) {
          case 'on_booking_date':
            due_date = vm.booking.start_date;
            break;
          case 'days_before_service':
            due_date = moment(vm.booking.start_date)
              .subtract(item.days_before_service, 'days')
              .format('YYYY-MM-DD');
            daysBeforeService = item.days_before_service;
            break;
          case 'on_service_date':
            due_date = vm.booking.booking_items[0].start_date;
            break;
          case 'pay_later':
            due_date = moment('9999-12-31').format('YYYY-MM-DD');
            break;
        }

        let consecutive =
          vm.incomingPrepayments.length > 0
            ? Math.max.apply(
                Math,
                vm.incomingPrepayments
                  .map((x) => (x.consecutive ? x.consecutive + 1 : 1))
                  .filter(Number)
              )
            : vm.incomingPrepayments.length + 1;

        consecutive = parseInt(consecutive);

        let amount = vm.UtilService.roundNum((item.percentage / 100) * vm.booking.total_price);

        incomingPrepayments.push({
          incoming_consecutive: vm.booking.booking_number + '-' + consecutive,
          due_date: due_date,
          percentage: item.percentage,
          amount: amount,
          type: 'incoming',
          payment_time: item.payment_time,
          days_before_service: daysBeforeService,
          status: 'pending',
          booking_status: vm.booking.status,
          company_id: vm.booking.company_id,
          booking_id: vm.booking.id,
        });
      });

      return incomingPrepayments.concat(updatedIncomingPrepayments);
    }
  }
})();
